// Na het terugzetten uit de prullenbak de kwalificeringsvragen opnieuw op het
// juiste meetmoment zetten. Een teruggezet meetmoment kan het nieuwe eerste
// zijn, en een teruggezette kwalificeringsvraag komt terug zonder haar
// uitsluitingen op de latere meetmomenten (codereview /complete 2026-10-28).
//
// Nodig naast `syncQualifyingExclusions` omdat de prullenbak alleen weet welk
// document hij terugzette, niet bij welke vragenlijst het hoort. Leest daarom
// eerst dat document, en bij een meetmoment het onderzoek erachter: de
// `QuestionnaireID` op een meetmoment is alleen bij het aanmaken gezet en kan
// verouderd zijn.
// AI-CONTEXT: See docs/features/sector-kwalificeringsvragen.md

import { db } from '../../firebase/config'
import isQualifyingQuestion from './isQualifyingQuestion'
import { syncQualifyingExclusions } from './applyQualifyingToggle'

/**
 * @param {{Collection: string, DocID: string}} item - De regel uit de prullenbak
 * @param {string} client - CompagnyID
 * @returns {Promise<void>}
 */
const resyncQualifyingAfterRestore = async (item, client) => {
    if (item?.Collection !== 'MeasureMoments' && item?.Collection !== 'QuestionnaireFields') return

    const snap = await db.collection(item.Collection).doc(item.DocID).get()
    if (!snap.exists) return
    const doc = snap.data()

    if (item.Collection === 'QuestionnaireFields') {
        if (!isQualifyingQuestion(doc)) return
        await syncQualifyingExclusions({ questionnaireId: doc.QuestionnaireID, client })
        return
    }

    const researchSnap = await db.collection('Research')
        .where('CompagnyID', '==', client)
        .where('ID', '==', doc.ResearchID)
        .get()
    const questionnaireId = researchSnap.docs[0]?.data()?.QuestionnaireID || ''
    await syncQualifyingExclusions({ questionnaireId, client })
}

export default resyncQualifyingAfterRestore
